function SourcesComponent(el) {
    this.el = el;
    this.toggleEl = el.querySelector('.jsSourcesToggle');
    this.panelEl = el.querySelector('.jsSourcesPanel');
    this.isOpen = false;
    this.init();
}

SourcesComponent.prototype.init = function() {
    this.toggleEl.addEventListener('click', () => this.toggle());
};

SourcesComponent.prototype.openInstant = function(onComplete) {
    gsap.killTweensOf(this.panelEl);
    gsap.set(this.panelEl, { clearProps: 'all' });
    this.el.classList.add('is-open');
    this.isOpen = true;
    this.toggleEl.setAttribute('aria-expanded', 'true');

    if (!onComplete) return;

    requestAnimationFrame(() => {
        requestAnimationFrame(onComplete);
    });
};

SourcesComponent.prototype.open = function(onComplete, animate) {
    if (animate === false) {
        this.openInstant(onComplete);
        return;
    }

    if (this.isOpen) {
        if (onComplete) onComplete();
        return;
    }

    this.el.classList.add('is-open');
    const newContentHeight = this.panelEl.scrollHeight;
    this.el.classList.remove('is-open');

    gsap.timeline()
        .set(this.panelEl, { height: 0 })
        .add(() => {
            this.el.classList.add('is-open');
            this.isOpen = true;
            this.toggleEl.setAttribute('aria-expanded', 'true');
        })
        .to(this.panelEl, { duration: 0.5, height: newContentHeight, ease: 'power2.inOut' })
        .set(this.panelEl, { clearProps: 'all' })
        .add(() => {
            if (onComplete) onComplete();
        })
    ;
};

SourcesComponent.prototype.close = function() {
    if (!this.isOpen) return;

    gsap.timeline()
        .to(this.panelEl, { duration: 0.5, height: 0, ease: 'power2.inOut' })
        .add(() => {
            this.el.classList.remove('is-open');
            this.isOpen = false;
            this.toggleEl.setAttribute('aria-expanded', 'false');
        })
        .set(this.panelEl, { clearProps: 'all' })
    ;
};

SourcesComponent.prototype.toggle = function() {
    if (this.isOpen) this.close();
    else this.open();
};

(function() {
    const bronHashPattern = /^#bron-(\d+)$/;
    const instances = [];

    function getScrollOffset() {
        const baseOffset = 20;
        const headerEl = document.querySelector('.header');

        if (!headerEl) return 50;

        const headerStyle = window.getComputedStyle(headerEl);

        if (headerStyle.position === 'fixed' || headerStyle.position === 'sticky') {
            return headerEl.getBoundingClientRect().bottom + baseOffset;
        }

        return 50;
    }

    function getSlugFromHash(hash) {
        if (!hash || hash === '#') return '';
        const rawSlug = hash.charAt(0) === '#' ? hash.substring(1) : hash;

        try {
            return decodeURIComponent(rawSlug);
        }
        catch (e) {
            return rawSlug;
        }
    }

    function getBronTarget(hash) {
        const slug = getSlugFromHash(hash);
        if (!slug || !slug.match(/^bron-\d+$/)) return null;
        return document.getElementById(slug);
    }

    function scrollToSourcesBlock(sourcesEl) {
        if (!sourcesEl || typeof vanillaSmoothie === 'undefined') return;

        const scrollTarget = sourcesEl.querySelector('.jsSourcesToggle') || sourcesEl;

        requestAnimationFrame(() => {
            vanillaSmoothie.scrollTo(scrollTarget.getBoundingClientRect().top + window.scrollY - getScrollOffset(), { duration: 500, easing: 'easeInOutQuad' });
        });
    }

    function getInstanceForTarget(targetEl) {
        const sourcesEl = targetEl.closest('.jsSourcesComponent');
        if (!sourcesEl) return null;

        for (let i = 0; i < instances.length; i++) {
            if (instances[i].el === sourcesEl) return instances[i];
        }

        return null;
    }

    function expandAndScrollToHash(hash) {
        const targetEl = getBronTarget(hash);
        if (!targetEl) return false;

        const instance = getInstanceForTarget(targetEl);
        if (!instance) return false;

        instance.open(() => scrollToSourcesBlock(instance.el), false);
        return true;
    }

    function handleBronHash(hash) {
        return expandAndScrollToHash(hash);
    }

    const sourcesEls = document.querySelectorAll('.jsSourcesComponent');
    for (let i = 0; i < sourcesEls.length; i++) instances.push(new SourcesComponent(sourcesEls[i]));

    if (window.location.hash && bronHashPattern.test(window.location.hash) && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    document.addEventListener('click', e => {
        const linkEl = e.target.closest('.c-sources-ref__link');
        if (!linkEl) return;

        const href = linkEl.getAttribute('href');
        if (!href || !bronHashPattern.test(href)) return;

        e.preventDefault();

        if (window.location.hash !== href) history.pushState(null, '', href);

        handleBronHash(href);
    });

    if (window.location.hash) handleBronHash(window.location.hash);

    window.addEventListener('hashchange', () => {
        if (window.location.hash) handleBronHash(window.location.hash);
    });
})();
